<div class="card-stack" *ngIf="slots.length > 0">
  <div *ngFor="let card of slots; let i = index; trackBy: trackBySlot"
       class="stack-card"
       [class.back-card]="i > 0 && !isPromoting(i)"
       [ngStyle]="getCardStyle(i, card)">
    <ng-container [ngTemplateOutlet]="card.templateRef"
                  [ngTemplateOutletContext]="{ dismiss: dismiss.bind(this) }">
    </ng-container>
  </div>
</div>
